import { keyframes } from 'styled-components/macro';
import { styled, css } from '../../components-v4/theme';
import { Dialog } from '../../components-v4';

export const StyledDialogContent = styled(Dialog.Content)`
  ${({ theme }) => css`
    align-items: center;
    width: 650px;
    min-height: 750px;

    ${theme.tokens.media.down('desktop')} {
      width: 100dvw;
      min-height: 100dvh;
    }
  `}
`;

export const StyledDialogPanel = styled(Dialog.Panel)`
  position: relative;
  width: 100%;
  height: 100%;
`;

const popIn = keyframes`
  0%   { transform: translateY(12px) scale(0.9); opacity: 0; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
`;

const ring = keyframes`
  0%   { box-shadow: 0 0 0 0px var(--ring-color); }
  100% { box-shadow: 0 0 0 20px transparent; }
`;

export const SuccessCircle = styled.div`
  ${({ theme }) => css`
    /* Переменная нужна, чтобы использовать в keyframes блоке анимации */
    --ring-color: ${theme.colors.green[100]};

    display: flex;
    justify-content: center;
    align-items: center;
    width: 180px;
    height: 180px;
    background-color: var(--ring-color);
    border-radius: ${theme.radiuses.full};
    animation: ${popIn} 500ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards,
      ${ring} 600ms ease-out 300ms forwards;

    .check-icon {
      animation: ${popIn} 400ms cubic-bezier(0.34, 1.56, 0.64, 1) 150ms both;
    }

    ${theme.tokens.media.down('desktop')} {
      width: 128px;
      height: 128px;
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.base};
    display: flex;
    gap: ${theme.spacings.base};
    width: 100%;

    ${theme.tokens.media.down('desktop')} {
      flex-direction: column-reverse;
      gap: ${theme.spacings.xs};
    }

    ${theme.tokens.media.tablet} {
      padding: ${theme.spacings.l};
    }
  `}
`;

export const MobileHeader = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.base};
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.spacings.base};

    ${theme.tokens.media.tablet} {
      padding-inline: ${theme.spacings.l};
      padding-block: ${theme.spacings.m};
    }
  `}
`;

export const MobileHeaderClose = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    color: ${theme.colors.primary[600]};
    cursor: pointer;
  `}
`;
